import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { AnvandareVikarieDto } from "./models/anvandareVikarieDto";
import { CreateAnvandareVikarieCommand } from "./models/createAnvandareVikarieCommand";
import { GetAnvandareVikarieQuery } from "./models/getAnvandareVikarieQuery";
import { UpdateAnvandareVikarieCommand } from "./models/updateAnvandareVikarieCommand";

@Injectable({
    providedIn: "root"
})
export class VikariehanteringService {
    private readonly apiClientService = inject(ApiClientService);

    getVirkeskopare(query: GetAnvandareVikarieQuery): Observable<AnvandareVikarieDto[]> {
        return this.apiClientService.post<GetAnvandareVikarieQuery, AnvandareVikarieDto[]>("administration/vikarie/search", query);
    }

    createAnvandareVikarie(command: CreateAnvandareVikarieCommand): Observable<AnvandareVikarieDto> {
        return this.apiClientService.post<CreateAnvandareVikarieCommand, AnvandareVikarieDto>("administration/vikarie/create", command);
    }

    updateAnvandareVikarie(command: UpdateAnvandareVikarieCommand): Observable<AnvandareVikarieDto> {
        return this.apiClientService.put<UpdateAnvandareVikarieCommand, AnvandareVikarieDto>("administration/vikarie/update", command);
    }

    deleteAnvandareVikarie(id: number): Observable<void> {
        return this.apiClientService.delete(`administration/vikarie/delete/${id}`);
    }
}
